import { combineReducers } from 'redux';
import login from 'components/login/actions';
import address from 'components/address/actions';
import product from 'components/product/actions';
import recommendation from 'components/recommendation/actions';
import cart from 'components/cart/actions';
import searchResults from 'components/searchResults/actions';
import category from 'components/category/actions';
import categoryGroup from 'components/categoryGroup/actions';
import checkout from 'components/checkoutPage/actions';
import payment from 'components/payment/actions';
import promo from 'components/promo/actions';
import orderTracking from 'components/orderTracking/actions';
import orderHistory from 'components/orderHistory/actions';
import link from 'components/link/actions';
import loyalty from 'components/loyalty/actions';
import storefront from 'components/storefront/actions';
import app from 'components/app/actions';
import userAddresses from 'components/userAddresses/actions';
import brands from 'components/brands/actions';
import gifting from 'components/gifting/actions';
import availability from 'components/availability/actions';
import substitutions from 'components/substitutions/actions';
import giftClaim from 'components/GiftClaim/actions';
import availableCategories from 'components/categoryLink/actions';
import cities from 'components/CityPage/actions';
import error from 'components/errorPages/actions';

export default combineReducers({
  login,
  address,
  product,
  recommendation,
  cart,
  searchResults,
  category,
  categoryGroup,
  checkout,
  payment,
  promo,
  orderTracking,
  orderHistory,
  link,
  loyalty,
  storefront,
  app,
  userAddresses,
  brands,
  gifting,
  availability,
  substitutions,
  giftClaim,
  availableCategories,
  cities,
  error
});
